import createApiServices from "./createApiServices"
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const getLayoutConfigSetting = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/crm/getLayoutConfigSetting?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const addLayOutConfigItem = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/crm/addLayOutConfigItem?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const deleteLayoutConfig = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/crm/deleteLayoutConfig?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const updateLayoutConfigItem = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/crm/updateLayoutConfigItem?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getSettingTenantParam = (query, userName) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/param?userName=${userName}&${query}`,
        method: 'GET'
    })
}

export const addSettingTenantParam = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/param?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const updateSettingTenantParam = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/param?userName=${userName}`,
        method: 'PUT',
        data: payload
    })
}

export const getTenantsDealer = (query, userName) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/searchTenantDealer?userName=${userName}&${query}`,
        method: 'GET',
    })
}

export const addTenantDealer = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/addTenantDealer?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getTenantDealer = (tenantId, userName) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/getTenantDealer?userName=${userName}&tenantId=${tenantId}`,
        method: 'GET'
    })
}

export const updateTenantDealer = (payload, userName) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/updateTenantDealer?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}